export class IssuerEdit
{
    public id = null;
    public version = null;
    public name = '';
    public description = '';
    public issuerUri = '';
    public authorizeUri = '';
    public tokenUri = '';
    public clientId = '';
    public enabled = true;
    public openIdUri = '';
    public secret = '';
}
